export class ForwardToStationSelectionResult {

  stationGroupId: number;
  stationSetId: number;
  stationId: number;

  reasonOptionDictionaryKey: string;

}
